import { useApolloClient } from '@apollo/client'
import { RefreshToken } from 'modules/ApolloClient/services'
import { UserToken, RefreshTokenResponse } from 'typings/auth'

export function useRefreshToken() {
    const client = useApolloClient()

    const refreshToken = async (userToken: UserToken): Promise<RefreshTokenResponse> => {
        delete userToken?.keepLogged?.keepLogged
        delete userToken?.keepLogged?.username
        if (userToken.token) {
            const { data } = await client.mutate<RefreshTokenResponse>({
                mutation: RefreshToken,
                variables: {
                    token: userToken.refreshToken,
                    KeepLogged: userToken?.keepLogged,
                },
            })
            return {
                refreshToken: {
                    access_token: data?.refreshToken.access_token,
                    refresh_token: data?.refreshToken.refresh_token,
                },
            }
        }

        return {
            refreshToken: {
                access_token: null,
                refresh_token: null,
            },
        }
    }

    return {
        refreshToken,
    }
}
